import { Component } from "react";

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div
                    data-testid="error-boundary"
                    className="flex min-h-screen items-center justify-center bg-ink px-6 text-center"
                >
                    <p className="font-display text-2xl text-cream/70">
                        Something went wrong.
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}
